import { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { parseLocationParams } from '../utils/utils';
import Page from '../components/page';
import { useSelector } from 'react-redux';
import { AppStore } from '../types';
import { AppLocalKey } from '../main';
import Button from '../components/button';
import { apiInviteUser } from '../api';
import { LoadingMask, showToast } from '../components/dialog';

export default function InvitePage() {
  const location = useLocation();
  const navigator = useNavigate();
  const [inviteUserId, setInviteUserId] = useState('');
  const configList = useSelector((state: AppStore) => state.systemConfig);
  const user = useSelector((state: AppStore) => state.user);
  useEffect(() => {
    let { userId } = parseLocationParams(location.search);
    if (userId) {
      setInviteUserId(userId);
    }
  }, [location]); /// eslint-disable-line
  async function handleInvite() {
    if (!user?.result?.id) {
      navigator('/login', { state: { invitationCode: inviteUserId } });
    } else {
      LoadingMask.show('正在加入...');
      try {
        var res = await apiInviteUser(inviteUserId);
        var data = res.data;
        if (data.code === 200) {
          navigator('/download', { replace: true });
        } else {
          showToast(data.msg ?? '加入失败');
        }
      } catch (e: any) {
        showToast(e.message ?? '加入失败');
      } finally {
        LoadingMask.hide();
      }
    }
  }

  var config = (configList?.results ?? []).find((i) => i.configKey === AppLocalKey.pageInviteConfig);
  return (
    <Page className="bg-color-gray" contentClassName="vw-100 vh-100 overflow-y">
      <img src={config?.configValue ?? ''} className="bw-100" alt="" />
      <div className="ph-30 pv-10">
        <Button long type="danger" shape="circle" size="md" className="h-40" onClick={handleInvite}>
          免费成为合伙人
        </Button>
      </div>
      <div className="m-10 bg-color-white p-10 border-radius-10 d-shadow">
        {(config?.remark ?? '').split('\n').map((i, idx) => (
          <div key={idx}>{i}</div>
        ))}
      </div>
    </Page>
  );
}
